import React from 'react';
import './MessageNotification.scss';
import { BsFillPersonFill } from "react-icons/bs";

const MessageNotification = ({ message, time }) => {
  return (
    <div className='bh'>
        <div className="sender-icon">
    <BsFillPersonFill size={35}/> {/* Icon will be styled as per the requirement */}
  </div>
    <div className="message-container">
      <div className="message-notification">
        <span className="message-text">Notify me that the changed recipient information has been modified, and a total of 1 note has been posted. Thank you!</span>
        <span className="message-time">17:09</span>
      </div>      
    </div>
    </div>
  );
};

export default MessageNotification;
